import { apiInstance, type CsrfTokenResponse, type ErrorResponse, postRequest } from '@/shared/api'

import type { SendOtpResponse } from './types'

import { GET_CSRF, LOGIN_URL, SEND_CODE_URL } from './constants'

export function getCsrf() {
    return apiInstance.get(`${GET_CSRF}`).json<CsrfTokenResponse>()
}

export function login(payload: { code: string; phone: string }) {
    return postRequest<unknown, ErrorResponse>(`${LOGIN_URL}`, payload, {
        body: `username=${payload.phone}&password=${payload.code}`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    })
}

export function sendOtp(payload: { phone: string; sector: number; signature: string }) {
    return postRequest<SendOtpResponse, ErrorResponse>(`${SEND_CODE_URL}`, payload)
}
